import React, {useCallback, useEffect, useRef, useState} from "react";
import {AppTheme, ColorMode} from "../../core/theme/theme.config";
import type {UserRole} from "../../core/roles/roles.type";
import {DropdownItem} from "./config/user-dropdown.config";
import UserDropdownView from "./user-dropdown.view";
import "../../styles/component/header/user-dropdown.scss";


export interface UserDropdownProps {
    role: UserRole;
    activeTheme: AppTheme;
    mode: ColorMode;
    onThemeChange: (theme: AppTheme) => void;
    onModeToggle: () => void;
    onNavigate: (path: string) => void;
    onLogout: () => void;
}

export default function UserDropdown(props: UserDropdownProps) {

    const [open, setOpen] = useState<boolean>(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const isLight = props.mode === "light";

    useEffect(() => {
        const onOutside = (e: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", onOutside);
        return () => document.removeEventListener("mousedown", onOutside);
    }, []);

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") setOpen(false);
        };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, []);

    const handleItemClick = useCallback((item: DropdownItem) => {
        if (item.disabled) return;
        setOpen(false);
        item.onClick(props.onNavigate, props.onLogout, props.role);
    }, [props.role, props.onNavigate, props.onLogout]);

    const handleModeToggle = useCallback(() => {
        props.onModeToggle();
    }, [props.onModeToggle]);

    return (
        <UserDropdownView
            handleModeToggle={handleModeToggle}
            role={props.role}
            open={open}
            setOpen={setOpen}
            activeTheme={props.activeTheme}
            containerRef={containerRef}
            handleItemClick={handleItemClick}
            onThemeChange={props.onThemeChange}
            isLight={isLight}
        />
    )
}
